import React from 'react'
import {
    Switch,
    Route,
    Redirect,
    withRouter,

    useLocation
} from 'react-router-dom';
import NotFound from './NotFound';
import Invitation from './Invitation';
import Premium from './BillingManager';
import Login from './login';
import TemplateEditor from './TemplateEditor';
import TeamManager from './TeamManager';
import TemplateList from './TemplateList';
import { useState } from 'react';
import { useEffect } from 'react';
import Other from './Other';

class PrivateRoute extends React.Component {
    state = {
        loaded: false,
        isAuthenticated: false
    };
    async checkUserAndSyncAuth(setGoogleAuthInvalid, onLogout) {
        const res = await fetch('/api/auth/checkuser', {
            credentials: 'include'
        });

        if (!res.ok) {
            onLogout();
            return false;
        }

        const data = await res.json();

        if (typeof setGoogleAuthInvalid === 'function') {
            setGoogleAuthInvalid(!!data.googleAuthInvalid);
        }


        return true;
    }
    async componentDidMount() {

        //this.unlisten = this.props.history.listen(async () => {

        //    const resp =
        //        await fetch('api/auth/checkuser', {
        //            method: 'GET',
        //            credentials: 'same-origin'
        //        });

        //    if (resp.status === 200) {

        //    }
        //    else {
        //        if (this.state.isAuthenticated) this.setState({ isAuthenticated: false })
        //    }


        //});
        (async () => { this.authenticate() })();
    }
    componentWillUnmount() {
        //this.unlisten()
    }
   
    async authenticate() {
        const ok = await this.checkUserAndSyncAuth(
            this.props.setGoogleAuthInvalid,
            () => this.setState({ loaded: true, isAuthenticated: false })
        );

        if (ok) {
            this.setState({ loaded: true, isAuthenticated: true });
        }
    }


   

    render() {

        const { loaded, isAuthenticated } = this.state

        if (!loaded) return null
        let comp = null;
        let restprops = null;
        if (!isAuthenticated) {

            comp = props => {
                return <Redirect
                    to={{
                        pathname: "/login",
                        state: { prevpath: props.location.pathname }
                    }}
                />
            }
        }
        else {
            if (!!this.props.render) {

                const { render: Render, ...rest } = this.props
                //TODO: I'm Warning: <Route> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.
                //now going between templatelist and other non render routes, yet it's passing the location props. Keep an eye out for location bugs later
                restprops = rest;

                comp = (props) => Render({ ...props });
            }
            else {
                const { component: Component, ...rest } = this.props
                restprops = rest;

                comp = props => {
                    return <Component {...props} />
                };
            }
        }


        return (
            <Route
                {...restprops}
                render={comp}
            />
        )
    }
}
PrivateRoute = withRouter(PrivateRoute)

const Routes = ({ authed, currentTeam, needsTeam, onTeamListChange, refreshUI, showBusy, driveId, googleAuthInvalid, setGoogleAuthInvalid,
            googleAccessToken, setGoogleAccessToken }) => {

    const location = useLocation();

    const passToInvitation = location.pathname.includes("invitation");
    const [stateTeam, setTeam] = useState(currentTeam);
    useEffect(() => {
        setTeam(currentTeam);
    }, [currentTeam]);

    return (
        needsTeam ? (passToInvitation ? <PrivateRoute path='/invitation/:invite?' render={(props) => <Invitation {...props} onTeamListChange={onTeamListChange} />} /> :
            <PrivateRoute render={(props) => <TeamManager {...props} currentTeam={stateTeam} onTeamListChange={onTeamListChange} />} />

        ) :
            (<Switch>
                <Route path='/login' render={(props) => <Login {...props} getUserInfo={refreshUI} />} />

                <PrivateRoute path='/billing/' render={(props) => <Premium {...props} showBusy={showBusy} />} />
                <PrivateRoute path='/invitation/:invite?' render={(props) => <Invitation {...props} onTeamListChange={onTeamListChange} />} />
                <PrivateRoute
                    path='/list/:id?'
                    render={(props) =>
                        <TemplateEditor
                            {...props}
                            currentTeam={stateTeam}
                            driveId={driveId}
                            googleAuthInvalid={googleAuthInvalid}
                            setGoogleAuthInvalid={setGoogleAuthInvalid}
                            googleAccessToken={googleAccessToken}
                            setGoogleAccessToken={setGoogleAccessToken}
                        />
                    }
                />


                <PrivateRoute path='/lists/' render={(props) => <TemplateList {...props} currentTeam={stateTeam} />} />
                <Redirect exact from='/start' to='/lists' />
                <PrivateRoute path='/other' render={(props) => <Other {...props} authed={authed} />} />
                <PrivateRoute path='/teams/' render={(props) => <TeamManager {...props} currentTeam={stateTeam} onTeamListChange={onTeamListChange} />} />
                <Route component={NotFound} />
            </Switch>))
}
export default Routes
